import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap"


import moment from "moment"
import IndexBloc from "./Blocs/IndexBlock"
import Select from "react-select"
import DatePicker from '../../../../helpers/ui/DatePicker'

import TableActiveComponent from './Components/TableActiveComponent'

var reformatOptions = function (raw, label, value) {
    return raw.map(function (data) {
        var newObj = {};
        newObj["label"] = data[label];
        newObj["value"] = data[value];

        return newObj;
    });
};

const IndexView = (props) => {
  
    let indexBloc = new IndexBloc();
    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();

    const [isLoadingSelectUnit, setIsLoadingSelectUnit] = useState(true);
    // Select
    const [optionUnits, setOptionUnits] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState("")
    
    // Filter
    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'))
    const [nip, setNip] = useState('')
    const [surat_tugas, setSuratTugas] = useState('')
    
    useEffect(() => {
        // get data unit
        indexBloc.workUnitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response.result
                        let options = reformatOptions(response, 'work_unit_name_tabs', 'work_unit_uuid');
                        setOptionUnits(
                            [
                                {
                                    label: 'Semua',
                                    value: 'all',
                                },
                                ...options
                            ]
                        )
                        setIsLoadingSelectUnit(false)
                    }
                    break
                case apiResponse.ERROR:
                    setIsLoadingSelectUnit(false)
                    break
                default:
                    break
            }
        })

        indexBloc.fetchWorkUnit({})

        return () => {
            indexBloc.workUnitChannel?.unsubscribe()
        }
    }, [])

    let additionalFilter = {
        work_unit: selectedUnit.value || "",
        start_date: startDate,
        end_date: endDate,
        nip: nip,
        surat_tugas: surat_tugas,
        
    };

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const exportExcel = () => activeRef.current.exportExcel()

    function handleButtonExport() {
        exportExcel()
    }

    function handleButtonSearch() {
      reloadActiveRef()
    }

    function handleButtonReset() {
        setSelectedUnit('')
        setTimeout(() => {
            reloadActiveRef()
        }, 300);
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">
                        
                        <Card>
                            <CardBody>
                                <div className="float-end">
                                {/* {
                                    (accessRole('create')) ?
                                        <Link to="home.html?create">
                                            <Button color="primary">New Sample</Button>
                                        </Link>
                                    : null
                                } */}
                                </div>
                                <CardTitle>List Data Monitoring Lembur</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Daftar Lembur Pegawai
                                </CardSubtitle>
                                <hr />

                                <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                        Unit Kerja
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionUnits.filter(option =>
                                                option.value === selectedUnit.value)}
                                            onChange={(s) => setSelectedUnit(s)}
                                            required="required"
                                            options={optionUnits}
                                            isLoading={isLoadingSelectUnit}
                                            classNamePrefix="select2-unit"
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label
                                        htmlFor="fielCode"
                                        className="col-md-2 col-form-label"
                                    >
                                    NIP
                                    </label>
                                    <Col md="4">
                                        <Input
                                            type="text"
                                            name="nip"
                                            value={nip}
                                            onChange={event => setNip(event.target.value)}
                                        >
                                    </Input>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label
                                        htmlFor="fielCode"
                                        className="col-md-2 col-form-label"
                                    >
                                    Surat Tugas
                                    </label>
                                    <Col md="4">
                                        <Input
                                            type="text"
                                            name="surat_tugas"
                                            value={surat_tugas}
                                            onChange={event => setSuratTugas(event.target.value)}
                                        >
                                    </Input>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label className="col-md-2">
                                        Periode Mulai
                                    </label>
                                    <Col md="3">
                                        <DatePicker 
                                            name="start_date"
                                            isWeekday={false}
                                            dateFormat="dd/MM/yyyy"
                                            placeholder="Tanggal Mulai"
                                            isAvForm={false}
                                            onChange={val => setStartDate(moment(val).format('YYYY-MM-DD'))}
                                            defaultValue={startDate}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label className="col-md-2">
                                        Periode Akhir
                                    </label>
                                    <Col md="3">
                                        <DatePicker 
                                            name="end_date"
                                            isWeekday={false}
                                            dateFormat="dd/MM/yyyy"
                                            placeholder="Tanggal Selesai"
                                            isAvForm={false}
                                            onChange={val => setEndDate(moment(val).format('YYYY-MM-DD'))}
                                            defaultValue={endDate}
                                        />
                                    </Col>
                                </Row>
                               
                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="10">
                                        <Button 
                                            color="primary" 
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                        {' '}
                                        {/* <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonReset()
                                          }}>
                                            <i className="uil-refresh"></i> Reset
                                        </Button> */}
                                        <Button
                                            color="success"
                                            type="button"
                                            onClick={() => {
                                                handleButtonExport()
                                            }}
                                        >
                                            Export Lembur
                                        </Button>
                                    </Col>
                                </Row>

                                <hr />
                                
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                            </CardBody>
                        </Card>
                        
                       
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView